export class RecipeStep {
    Stage: RecipeStepData;
}

export class RecipeStepData {
  Id_Stage: number;
  Id_Recipe: number;
  Id_Stage_Recipe: number;
  StageOrder: number;
  StageText: string;
  Text: string;
  ImagePath: string;
  Image: string;
  ImageSize = null;
  StateForChange: number;
  ImageFile: File;
  IsImageUpdated = false;
  ImageToShow: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/recipe-step-model.ts